module.exports = __webpack_public_path__ + "static/img/home_xxxt_1.c89599f1.png";